// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1gZVA","containerItemsCenter":"Skeleton_containerItemsCenter__1w0ia"};